import { useCallback, useEffect, useState } from "react";
import { ConvertToFloat, IsNumberKeyWithoutZero } from "../../../Layout/Common/common";
import { ImageWithDefault } from "../../../Layout/Common/imageWithDefault";
import { WishlistItem } from "../../../Layout/Common/addWhistList";
import useAddToCart from "../../../Context/hook/useAddtoCart";
import { debounce } from "lodash";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { useNoteAlert } from "../../../Context/pleaseNote";
import { ProductLink } from "../../../Layout/Common/productLink";
import { ItemReferenceInput } from "../../../Layout/Common/itemReferenceInput";

export const PendingOrderItemRow = ({ row, index, onSyncUpdate, isLastItem = false }) => {
  const [item, setItem] = useState(null);
  const [qty, setQty] = useState(1);
  const { handleUpdateCartItem } = useAddToCart();
  const { deletePendingOrderProduct } = useGlobalFunction();
  const { hideNoteAlert, showDialogAlert } = useNoteAlert();
  useEffect(() => {
    if (row) {
      setItem(row);
      setQty(parseInt(row.qty));
    }
  }, [row]);

  const unitPrice = (it) => {
    const qty = parseFloat(it.qty);
    const ext = parseFloat(it.total_ext);
    return qty > 0 ? ext / qty : ext;
  };

  const QuantityInc = () => {
    let currentqty = parseInt(qty + 1);
    setQty(currentqty);
    debouncedFunction(item.prod_id, currentqty, "INC");
  };
  const QuantityDec = () => {
    if (qty > 1) {
      setQty(parseInt(qty - 1));
      debouncedFunction(item.prod_id, parseInt(qty - 1), "DEC");
    }
  };

  const handleOnChange = (e) => {
    var value = IsNumberKeyWithoutZero(e.target.value);
    setQty(value);
    debouncedFunction(item.prod_id, parseInt(value), "INC");
  };

  const debouncedFunction = useCallback(
    debounce(async (p, value, type) => {
      let result = await handleUpdateCartItem(
        item.order_id,
        p,
        value,
        type,
        item.description,
        item.image_th,
        item.prod_code,
      );
      if (result === false) {
        setQty(item.qty);
      } else {
        setItem((prev) => ({ ...prev, qty: value }));
        onSyncUpdate && onSyncUpdate(item.order_id);
      }
    }, 1000),
    [item],
  );

  const removeCard = (item) => {
    showDialogAlert({
      content: isLastItem
        ? "This is the last item in this order. Removing it will delete the whole order permanently."
        : "Do you want to remove this product from the order?",
      title: "Delete Confirmation",
      primaryBtn: {
        caption: "Yes, Remove",
        onClick: () => orderDeletefun(item),
      },
      scondaryBtn: {
        caption: "Cancel",
        onClick: hideNoteAlert,
      },
    });
  };

  const orderDeletefun = async (item) => {
    await deletePendingOrderProduct(item);
    onSyncUpdate && onSyncUpdate(item.order_id, { deleteWhenEmpty: true });
  };

  return (
    <div className="col-lg-12 order-history-item" key={index}>
      {item && (
        <div className="cart-added-products" style={{ border: "none" }} data-id={item.prod_id}>
          <div className="added-cartPro-img">
            <ImageWithDefault src={item.image_th} alt={item.description} />
          </div>
          <div className="added-cartPro-content">
            <div className="added-cartPro-info">
              <div className="added-cartPro-item">
                <h6>
                  <ProductLink to={item.product_url}>{item.description}</ProductLink>
                </h6>
                <p>
                  <span>Code: {item.prod_code}</span>${ConvertToFloat(unitPrice(item))} each
                </p>
              </div>
              <div className="cart-remove-wishlist">
                <button
                  type="submit"
                  className="cc-cart-delete"
                  onClick={() => {
                    removeCard(item);
                  }}
                >
                  <i className="fa-regular fa-trash-can" />
                </button>
              </div>
            </div>
            <div className="added-cartPro-price">
              <p>${ConvertToFloat(item.total_ext)}</p>
              {item.isErrorItem ? (
                <div className="qty-container orderErrorItem">{item.error_message}</div>
              ) : (
                <div className="product-quantity" key={item.prod_id}>
                  <div className="qty-container">
                    <button className="qty-btn-minus btn-light" type="button" onClick={QuantityDec}>
                      <i className="fa fa-minus" />
                    </button>
                    <input type="text" name="qty" value={qty} className="input-qty" onChange={handleOnChange} />
                    <button className="qty-btn-plus btn-light" type="button" onClick={QuantityInc}>
                      <i className="fa fa-plus" />
                    </button>
                  </div>
                </div>
              )}
            </div>
            <ItemReferenceInput item={item} />
          </div>
        </div>
      )}
    </div>
  );
};
